import { TextKey } from '@mews-commander/enums';
import { LocalizedTypography } from '@mews-commander/ui';

interface ItemCountLabelProps {
    count: number;
}

export const ItemCountLabel = ({ count }: ItemCountLabelProps) =>
    count === 0 ? (
        <LocalizedTypography textStyle="bodySmall" variant="secondary" textKey={TextKey.Empty} as="div" />
    ) : (
        <LocalizedTypography
            textStyle="bodySmall"
            variant="secondary"
            textKey={TextKey.GeneralItemsCount}
            substitutes={{ count }}
            as="div"
        />
    );
